import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  overflow: auto;
  margin-top: 34px;
`;

Wrapper.displayName = 'FieldListWrapper';

export default Wrapper;
